import * as React from "react";
import type { SVGProps } from "react";
const SvgGolfClub = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#golf-club_svg__a)">
      <path d="M10.57 15h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2M14.57 18h-10a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2" />
      <path d="M14.39 22H4.57a4.67 4.67 0 0 1-3.33-1.38 4.7 4.7 0 0 1-1.1-4.41l.93-3.86A5 5 0 0 1 6.7 8.58l8 1.23a.42.42 0 0 0 .47-.36v-.12l1.92-6.61A1 1 0 0 1 18.32 2 1 1 0 0 1 19 3.24l-1.9 6.55a2.42 2.42 0 0 1-2.73 2l-8-1.24A3 3 0 0 0 3 12.81l-.93 3.87a2.68 2.68 0 0 0 .61 2.53 2.7 2.7 0 0 0 1.89.79h9.78a3.11 3.11 0 0 0 3.05-2.62.3.3 0 0 1 0-.1l3.77-14.53a1 1 0 1 1 1.94.5l-3.7 14.48A5 5 0 0 1 14.39 22" />
      <path d="M20.49 8.9a1 1 0 0 1-.24 0L16.66 8a1.03 1.03 0 0 1 .49-2l3.58.9a1 1 0 0 1 .73 1.21 1 1 0 0 1-.97.79" />
    </g>
    <defs>
      <clipPath id="golf-club_svg__a">
        <path fill="#fff" d="M0 2h23.14v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGolfClub;
